declare global {
  interface Window {
    _env_?: Readonly<Record<string, string | undefined>>;
  }
}

/**
 * Reads a configuration value from the runtime config injected by the
 * container at startup (window._env_, generated into config.js by
 * nginx/generate-runtime-config.mjs), falling back to the build-time
 * process.env value.
 *
 * The fallback keeps the dev server and tests working unchanged: public/config.js
 * is an empty default that the container overwrites.
 */
export const runtimeEnv = (key: string): string | undefined =>
  window._env_?.[key] ?? process.env[key];
